export const debugWatchlistData = {
  alertList: {
    matches: [
      {
        element: 'ssn',
        datasetName: 'consortium',
        reason: 'Identity Fraud',
        industryName: 'E-Commerce',
        lastReportedDate: '2018-12-20',
        reportedCount: 3,
      },
    ],
    reasonCodes: ['R111'],
  },
  globalWatchlist: {
    matches: {
      ofacConsolidatedList: [
        {
          comments: {
            aka: ['Michael Martelly', 'Sweet Micky'],
            url: ['https://sanctionssearch.ofac.treas.gov/'],
            name: ['Michel Joseph Martelly'],
            gender: ['male'],
            address: [
              'Miami, FL, United States',
              'Petionville, Ouest, Haiti',
              'Port-au-Prince, Ouest, Haiti',
              'Dominican Republic',
            ],
            akaList: [
              "{'name': 'Michael MARTELLY', 'type': 'a.k.a.', 'category': 'strong'}",
              "{'name': 'Sweet Micky', 'type': 'a.k.a.', 'category': 'weak'}",
            ],
            offence: ['Sanction'],
            offense: ['Sanction'],
            program: ['ILLICIT-DRUGS-EO14059'],
            lastName: ['MARTELLY'],
            listName: ['OFAC Consolidated List'],
            countries: ['US', 'HT', 'DO'],
            firstname: ['Michel Joseph'],
            listingId: ['OFAC-50476'],
            entityType: ['Individual'],
            sourceCode: ['OFAC'],
            addressList: [
              "{'city': 'Port-au-Prince', 'stateOrProvince': 'Ouest', 'country': 'Haiti'}",
              "{'country': 'Dominican Republic'}",
              "{'city': 'Miami', 'stateOrProvince': 'FL', 'country': 'United States'}",
              "{'city': 'Petionville', 'stateOrProvince': 'Ouest', 'country': 'Haiti'}",
            ],
            dateOfBirth: ['1961-02-12'],
            nationality: ['Haiti'],
            yearOfBirth: ['1961'],
            additiondate: ['2025-01-15-10-02'],
            placeofbirthlist: ['Port-au-Prince, Haiti'],
            identificationsList: [
              "{'idType': \"Driver's License No.\", 'idNumber': 'M634550610520', 'idCountry': 'United States'}",
              "{'idType': 'Executive Order 14059 information:', 'idNumber': 'Prohibition on any United States person from investing in or purchasing significant amounts of equity or debt instruments of this target'}",
              "{'idType': 'Executive Order 14059 information:', 'idNumber': 'Prohibition on any transactions in foreign exchange that are subject to the jurisdiction of the United States and in which this target has any interest'}",
              "{'idType': 'National ID No.', 'idNumber': '0032768386', 'idCountry': 'Haiti'}",
              "{'idType': 'Executive Order 14059 information:', 'idNumber': 'Prohibition on any United States financial institution from making loans or providing credit to this target'}",
              "{'idType': 'Gender', 'idNumber': 'Male'}",
            ],
            originalCountryText: [
              'Haiti',
              'United States',
              'Dominican Republic',
            ],
          },
          entityId: 'ZaP+/U4QQowsYGxKbVMOuFSO',
          matchScore: 98,
          sourceUrls: ['https://sanctionssearch.ofac.treas.gov/'],
          matchFields: ['dobExact', 'nameExact'],
          entityCorrelationScore: 99,
        },
      ],
    },
    reasonCodes: ['R181', 'R186'],
  },
};
